module.exports = __webpack_public_path__ + "static/media/increase.790a5d48.svg";